import { render, staticRenderFns } from "./PickWait.vue?vue&type=template&id=2d034cd4&scoped=true"
import script from "./PickWait.vue?vue&type=script&lang=js"
export * from "./PickWait.vue?vue&type=script&lang=js"
import style0 from "./PickWait.vue?vue&type=style&index=0&id=2d034cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d034cd4",
  null
  
)

export default component.exports